import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { IconButtonSizeType, IconButtonVariantType, } from '../../../../../../components/iconButton/types/iconButton';
import { RadioButtonGroupVariantType } from '../../../../../../components/radioButtonGroup/types/radioButtonGroupVariantType';
import { SelectorCardContentStateType } from '../../../../../../components/selectorCardContent/types/selectorCardContentStateType';
import { SelectorCardContentVariantType } from '../../../../../../components/selectorCardContent/types/selectorCardContentVariantType';
import { CheckboxVariantType } from '../../checkbox/variants';
import { IconHighlightedVariantType } from '../../iconHighlighted/variants';
import { TooltipVariantType } from '../../tooltip/variants';
const commonStateStyles = (FOUNDATIONS, styles) => {
    return {
        rootContainer: {
            position: 'relative',
            ...styles?.rootContainer,
        },
        contentContainer: {
            border: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_160}`,
            border_radius: FOUNDATIONS.radius_250,
            padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250}`,
            background_color: FOUNDATIONS.color_comp_containers_bg,
            display: 'flex',
            flex_direction: 'row',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_150,
            ...styles?.contentContainer,
        },
        infoContainer: {
            flex_grow: '1',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'flex-start',
            ...styles?.infoContainer,
        },
        dataContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'column',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_100,
            ...styles?.dataContainer,
        },
        dataHeaderContainer: {
            width: '100%',
            display: 'flex',
            flex_direction: 'row',
            align_items: 'flex-start',
            gap: FOUNDATIONS.spacing_200,
            ...styles?.dataHeaderContainer,
        },
        customHeaderContainer: {
            flex_grow: '1',
            ...styles?.customHeaderContainer,
        },
        customContentContainer: {
            width: '100%',
            ...styles?.customContentContainer,
        },
        input: {
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            border_radius: FOUNDATIONS.radius_250,
            cursor: 'pointer',
            width: '100%',
            height: '100%',
            ...styles?.input,
        },
        decorativeElement: {
            ICON: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_350,
                color: FOUNDATIONS.color_secondary_icon_100,
                ...styles.decorativeElement?.ICON,
            },
            ICON_HIGHLIGHTED: {
                variant: IconHighlightedVariantType.CIRCLE_IMAGE,
                size: IconHighlightedSizeType.EXTRA_SMALL,
                ...styles.decorativeElement?.ICON_HIGHLIGHTED,
            },
        },
        checkbox: {
            variant: CheckboxVariantType.REGULAR,
            ...styles?.checkbox,
        },
        radioButton: {
            variant: RadioButtonGroupVariantType.REGULAR,
            ...styles?.radioButton,
        },
        tooltip: {
            variant: TooltipVariantType.REGULAR,
            ...styles?.tooltip,
        },
        tooltipIconButton: {
            variant: IconButtonVariantType.SECONDARY,
            size: IconButtonSizeType.SMALL,
            ...styles?.tooltipIconButton,
        },
    };
};
export const getCustomStyles = (FOUNDATIONS, FONT) => {
    return {
        [SelectorCardContentVariantType.CUSTOM]: {
            [SelectorCardContentStateType.DEFAULT]: commonStateStyles(FOUNDATIONS, {}),
            [SelectorCardContentStateType.PRESSED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                    // simulate no border without changing the size
                    border_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
            }),
            [SelectorCardContentStateType.SELECTED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                    border_color: FOUNDATIONS.color_accent_selected_border_50,
                },
            }),
            [SelectorCardContentStateType.DISABLED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_color: FOUNDATIONS.color_accent_disabled_border_150,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
                decorativeElement: {
                    ICON: {
                        color: FOUNDATIONS.color_accent_disabled_icon_100,
                    },
                },
            }),
            [SelectorCardContentStateType.DISABLED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                    border_color: FOUNDATIONS.color_accent_disabled_border_100,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
                decorativeElement: {
                    ICON: {
                        color: FOUNDATIONS.color_accent_disabled_icon_50,
                    },
                },
            }),
            [SelectorCardContentStateType.BLOCKED_SELECTED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_comp_forms_selectorcardcontent_blocked_bg,
                    border_color: FOUNDATIONS.color_feedback_error_border_50,
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
                decorativeElement: {
                    ICON: {
                        color: FOUNDATIONS.color_feedback_error_icon_50,
                    },
                },
            }),
            [SelectorCardContentStateType.BLOCKED_UNSELECTED]: commonStateStyles(FOUNDATIONS, {
                contentContainer: {
                    background_color: FOUNDATIONS.color_comp_forms_selectorcardcontent_blocked_bg,
                    border_color: FOUNDATIONS.color_feedback_error_border_50,
                },
                decorativeElement: {
                    ICON: {
                        color: FOUNDATIONS.color_feedback_error_icon_50,
                    },
                },
                input: {
                    cursor: 'default',
                    pointer_events: 'none',
                },
            }),
        },
    };
};
//# sourceMappingURL=custom.js.map